import { ApiResponse, DataWithPagination } from '@/shared/types';
import {
  Process,
  ProcessBaseInfo,
  ProcessDetails,
  ProcessItem,
  UserProcess,
} from '../domain';
import { CreateProcessJson, EditProcessJson } from '../types';

export abstract class ProcessRepository {
  abstract getAllProcesses(
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<ProcessItem[]>>;
  abstract createProcess(data: CreateProcessJson): Promise<void>;
  abstract getProcess(id: number): Promise<ProcessDetails>;
  abstract enableProcess(id: number): Promise<ApiResponse<unknown>>;
  abstract disableProcess(id: number): Promise<ApiResponse<unknown>>;
  abstract updateProcess(data: EditProcessJson): Promise<ApiResponse<unknown>>;
  abstract getProcessesByBusinessArea(
    businessAreaId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<Process[]>>;
  abstract getProcessesBaseInfoByBusinessArea(
    businessAreaId: number,
  ): Promise<ProcessBaseInfo[]>;
  abstract getProcessesByCompany(
    companyId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<Process[]>>;
  abstract getProcessesByOrganization(
    organizationId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<Process[]>>;
  abstract getProcessesByUser(
    userId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<UserProcess[]>>;
  abstract deleteProcess(Id: number): Promise<ApiResponse<unknown>>;
}
